import { ConfirmContext, ConfirmProvider } from '@shared/libs/context/ConfirmContext';
import { useContext } from 'react';

export const useConfirm = (): ConfirmProvider => {
  const context = useContext(ConfirmContext);

  if (!context) {
    throw new Error('useConfirm must be used within an ConfirmContext');
  }

  return context;
};
